import constants from 'src/constants';

const isMobileDevice = () => {
  const minimumPixels = constants.app.MINIMUM_TABLET_SCREEN_PIXELS;
  const height = window.innerHeight;
  const width = window.innerWidth;

  return width < minimumPixels || height < minimumPixels;
};

export default {
  isMobileDevice,
};
